module.exports = __webpack_public_path__ + "static/media/Hoist_ios_5.0fda2b01.jpg";